export enum VolumeMetricUnitsEnum {
    ml = "ML",
    l = "L",
    //...
}
